import type { AccountTypes, DraftAccount } from '@interfaces/account';
import { AccountStates } from '@interfaces/account';
import type { Goal } from '@interfaces/goalSubAccountTypes';
import type { User } from '@interfaces/user';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box } from '@ovComponents/1-primative/box/box';
import { Icon } from '@ovComponents/1-primative/icon/icon';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { Button } from '@ovComponents/2-component/button/button';
import { Form } from '@ovComponents/2-component/form/form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GoalLinkingInput, getValidGoals } from '../goalLinking';

export const AccountDialogContent = ({
  accountType,
  userData,
  onAccountCreated,
  onDialogClose,
}: {
  accountType: AccountTypes;
  userData: User;
  showGoalLinkingSection: boolean;
  onAccountCreated: (account: DraftAccount) => void;
  onDialogClose: () => void;
}) => {
  const { t } = useTranslation(['accountTypes', 'workflowCompletions']);
  const [goalsLinked, setGoalsLinked] = useState<Goal[]>([]);
  const goals = getValidGoals(userData);
  const submit = () => {
    onAccountCreated({
      type: accountType,
      applyForGovFunds: [],
      id: '',
      state: AccountStates.ACTIVE,
      user: userData,
      goalsLinked,
    });
  };

  return (
    <Form onSubmit={submit}>
      <Box display='flex' flexDirection='row' justifyContent='end'>
        <Box sx={{ cursor: 'pointer' }} display='flex' onClick={onDialogClose}>
          <Icon icon={CloseRoundedIcon} size='medium' />
        </Box>
      </Box>
      <Typography variant='headingMedium' sx={{ mt: 1 }}>
        {t(`accountTypes:${accountType}`)}
      </Typography>
      <Box sx={{ mt: 4 }}>
        <GoalLinkingInput
          goals={goals}
          goalsLinked={goalsLinked}
          setGoalsLinked={setGoalsLinked}
        />
      </Box>
      <Box width='100%' display='flex' justifyContent='end'>
        <Button
          color='primary'
          label={t('workflowCompletions:baseAccountCreation.addAccount')}
          disabled={false}
          sx={{ mt: 3 }}
          type='submit'
        />
      </Box>
    </Form>
  );
};
